import { createStore, applyMiddleware } from 'redux'
import { composeWithDevTools } from 'redux-devtools-extension'
import thunk from 'redux-thunk'

import initialState from './initialState'
import rootReducer from './rootReducer'

const store = createStore(rootReducer, initialState, composeWithDevTools(applyMiddleware(thunk)))

window.store = store

export {store as default}



// WEBPACK FOOTER //
// ./assets/redux/store.js